import React from 'react';
import TagsMenu, { TagsMenuInterface } from "src/componets/Tags/TagsMenu";

const TYPES: any = [
  {
    name: 'Addon',
    key:  'addon'
  },
  {
    name: 'Skin',
    key: 'skin'
  },
  {
    name: 'World',
    key:  'world'
  },
  {
    name: 'Skin Pack',
    key:  'skin_pack'
  },
  {
    name: 'Post',
    key: 'post'
  },
  {
    name: 'Structure',
    key: 'structure'
  }
];

const _MenuTypes = () => {
  const renderItems: TagsMenuInterface['items'] = [];

  TYPES.forEach(({ key, name }: any) => {
    renderItems.push({
      label: name,
      color: '#1890ff',
      key: key
    });
  });

  return (
    <TagsMenu
      className='v-menu-tags'
      paramsKey='add_type'
      items={renderItems}
    />
  )
}

export default _MenuTypes;
